"use strict";

var _defineProperty = require("/Users/nightmail/Documents/SourceCode/codb.io/web/node_modules/@babel/runtime/helpers/defineProperty");

var _objectSpread = require("/Users/nightmail/Documents/SourceCode/codb.io/web/node_modules/@babel/runtime/helpers/objectSpread");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var lodash_1 = __importDefault(require("lodash"));

function concatAndUnion(oldList, newList, differ) {
  var list = lodash_1.default.concat(oldList, newList);
  list = lodash_1.default.unionBy(list, differ);
  return list;
}

exports.concatAndUnion = concatAndUnion;

function removeByIndex(arr, idx) {
  var cloned = lodash_1.default.clone(arr);
  cloned.splice(idx, 1);
  return cloned;
}

exports.removeByIndex = removeByIndex;

function replaceByIndex(arr, idx, replacer) {
  var cloned = lodash_1.default.clone(arr);
  cloned[idx] = replacer;
  return cloned;
}

exports.replaceByIndex = replaceByIndex;

function replaceByProps(list, mapProps, replacer) {
  return lodash_1.default.map(list, function (u) {
    if (lodash_1.default.isMatch(u, mapProps)) {
      return replacer;
    } else {
      return u;
    }
  });
}

exports.replaceByProps = replaceByProps;

function replaceByFunc(list, replacer, compareFunc) {
  var isAppendIfNotExist = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
  var isReplaced = false;
  var newList = lodash_1.default.map(list, function (u) {
    if (compareFunc(u, replacer)) {
      isReplaced = true;
      return replacer;
    } else {
      return u;
    }
  });

  if (isAppendIfNotExist && isReplaced === false) {
    newList.push(replacer);
  }

  return newList;
}

exports.replaceByFunc = replaceByFunc;

function replaceByPropsOrAddIfNotExist(list, mapProps, replacer) {
  var found = lodash_1.default.find(list, mapProps);

  if (found) {
    return replaceByProps(list, mapProps, replacer);
  } else {
    return lodash_1.default.concat(list, replacer);
  }
}

exports.replaceByPropsOrAddIfNotExist = replaceByPropsOrAddIfNotExist;

function removeByProps(list, mapProps) {
  var result = [];
  lodash_1.default.forEach(list, function (u) {
    if (!lodash_1.default.isMatch(u, mapProps)) {
      result.push(u);
    }
  });
  return result;
}

exports.removeByProps = removeByProps;

function push(list, item) {
  var next = lodash_1.default.clone(list);
  next.push(item);
  return next;
  ;
}

exports.push = push;

function unshift(list, item) {
  var next = lodash_1.default.clone(list);
  next.unshift(item);
  return next;
}

exports.unshift = unshift;

function lookup(targets, refs, targetRefId, refId, targetRefProp) {
  var result = [];
  lodash_1.default.forEach(targets, function (target) {
    var targetRef = target[targetRefId];
    var query = {};
    query[refId] = targetRef;
    var found = lodash_1.default.find(refs, query);

    if (!found) {
      result.push(_objectSpread({}, target, _defineProperty({}, targetRefProp, null)));
    } else {
      result.push(_objectSpread({}, target, _defineProperty({}, targetRefProp, found)));
    }
  });
  return result;
}

exports.lookup = lookup;

function selectOnArray(list, target) {
  if (list.indexOf(target) === -1) {
    return lodash_1.default.concat(list, target);
  } else {
    return lodash_1.default.without(list, target);
  }
}

exports.selectOnArray = selectOnArray;